import {
  signingAvailability,
  type DocumentWorkflowFileVersion,
  type SigningAvailability,
} from "../entities/document-workflow";
import { useDocumentFiles } from "./documentFilesContext";

/** Причины, общие для всех файлов документа: их показывают один раз. */
export function isGlobalReason(availability: SigningAvailability): boolean {
  return (
    availability.status === "unavailable" &&
    availability.reason !== "version_not_ready"
  );
}

/** Можно ли подписать версию: ответ сервера, право, браузер и сама версия. */
export function useSigningAvailability(
  version: Pick<DocumentWorkflowFileVersion, "scan_status" | "sha256">,
) {
  const { services, canSign, signatureCapabilities } = useDocumentFiles();
  const availability = signingAvailability({
    capabilities: signatureCapabilities,
    canSign,
    browserProfiles: services.cryptoPro?.supportedProfiles ?? [],
    version,
  });

  return {
    availability,
    capabilities:
      signatureCapabilities.state === "ready"
        ? signatureCapabilities.data
        : null,
  };
}
